export function Start(btn: HTMLElement) {
    if (btn.querySelector('.spinner-border')) {
        return;
    }

    const spinner = document.createElement('span');
    spinner.classList.add('spinner-border', 'spinner-border-sm');
    spinner.setAttribute('role', 'status');

    btn.insertBefore(spinner, btn.firstChild);
    btn.setAttribute('disabled', 'disabled');
}

export function Stop(btn: HTMLElement) {
    const spinner = btn.querySelector('.spinner-border');

    if (!spinner) {
        return;
    }

    btn.removeChild(spinner);
    btn.removeAttribute('disabled');
}